import React from 'react';
import { makeStyles, Box, Typography, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import CardWithProgressLoading from '../CardWithLoadingProgress';

import { USEFUL_LINKS_ITEMS } from '../../../constants/usefulLinksItems';

import styles from './styles';

const useStyles = makeStyles(styles);

const UsefulLinksWidget = () => {
  const { t } = useTranslation('common');
  const classes = useStyles();

  return (
    <CardWithProgressLoading
      className={classes.card}
      loading={false}
      fullHeight={false}
    >
      <Typography variant="h6" className={classes.title}>
        {t('usefulLinks.title')}
      </Typography>

      <Box className={classes.content}>
        {USEFUL_LINKS_ITEMS.map((item) => (
          <Button
            key={`useful-link-${item.label}`}
            type="button"
            variant="contained"
            color="secondary"
            size="small"
            href={item.url}
            target="_blank"
            underline="none"
          >
            {t(`usefulLinks.items.${item.label}.label`)}
          </Button>
        ))}
      </Box>
    </CardWithProgressLoading>
  );
};

export default UsefulLinksWidget;
